// extracted by mini-css-extract-plugin
export default {"container":"Progress_container__QhisS","slider":"Progress_slider__10ANs"};